import { render, staticRenderFns } from "./ListMedfpostgrad.vue?vue&type=template&id=2845d73a&"
import script from "./ListMedfpostgrad.vue?vue&type=script&lang=js&"
export * from "./ListMedfpostgrad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports